'use strict';
/**
 * Main screen controller for the logs screen
 */
angular.module('autoremind')
    .controller('autoremind.MainController', ['$scope', '$location', '$route', 'logger', 'localize',
    function ($scope, $location, $route, logger, localize) {
        logger.info('In main controller');
        //$scope.isLoaded = true;
        // Initialize
        $scope.isLoggedIn = false; // TODO: Get from local storage?
        // Map services for use in view
        //$scope.userSettings = userSettings;
        localize.setLanguage('en-US');
        /*$scope.$on('event:toogle-sidebar', function() {
            userSettings.model.hideSidebar = ! userSettings.model.hideSidebar;
        });*/
    }]);
/**********************************************************************************/
angular.module('autoremind')
    .controller('autoremind.ProgressBarController', 
// Setup dependencies
['$scope', '$rootScope', '$interval', 'logger', 'userProfile', 'accountService',
    function ($scope, $rootScope, $interval, logger, userProfile, accountService) {
        // Initialize
        logger.info('In ProgressBar Controller');
        $scope.tickProgress = 1;
        $scope.appointmentsProgressing = 0;
        var stopHandler = undefined;
        $scope.update = function () {
            // Don't start a new update if we are already updating
            if (angular.isDefined(stopHandler))
                return;
            stopHandler = $interval(function () {
                $scope.polling = true;
                if (accountService.currentUser !== undefined) {
                    $scope.tickProgress++;
                    $rootScope.$broadcast('event:updateTick');
                    if ($scope.tickProgress === 11) {
                        $rootScope.$broadcast('event:updateFull');
                        // TODO: Get progress data from backend and update view
                        $scope.tickProgress = 1;
                    }
                }
                // UNCOMMENT TO STOP UPDATING                $interval.cancel(stopHandler);
            }, 1000);
        };
        $scope.stopUpdate = function () {
            if (angular.isDefined(stopHandler)) {
                $interval.cancel(stopHandler);
                stopHandler = undefined;
            }
        };
        // Start update timer
        $scope.update();
        $scope.toggleUpdate = function () {
            if (angular.isDefined(stopHandler)) {
                $interval.cancel(stopHandler);
                stopHandler = undefined;
                $scope.viewModel.polling = false;
                // Remember state of progress bar
            }
            else {
                $scope.viewModel.polling = true;
                $scope.update();
                // Restore state of progress bar
            }
        };
    }]);
/**********************************************************************************/
/**********************************************************************************/
/**
 * TODO: Remove it if its not being used
 */
angular.module('autoremind')
    .controller('autoremind.dashboard.ScreenController_dummy', 
// TODO Implement some dispatching depending on rights. using reseller version for now.  
['$scope', 'logger', 'accountService',
    function ($scope, logger, accountService) {
        // Initialize
        $scope.viewModel = {};
        // Map the service to the scope model for use in the view
        $scope.accountService = accountService;
    }]);
//# sourceMappingURL=autoremind.controllers.js.map